<template>
  <div>
    <jwplayer ref="jwplayer" :options="this.$manager.jwOptions"></jwplayer>
  </div>
</template>

<script>

  import PlayerMixin from '../mixins/PlayerMixin.vue'

  export default {

    name: 'VRDemoPlayer',

    mixins: [PlayerMixin],

    data () {
      return {
      }
    },

    mounted () {
        this.$l.log('canvas is ready')
      this.vrdemo()
    },

    methods: {

      vrdemo () {
        this.$manager.addPlaylist([{
          title: 'Caminandes VR',
          mediaid: 'AgqYcfAT',
          stereomode: 'monoscopic',
          file: '//vr.jwplayer.com/content/AgqYcfAT/AgqYcfAT-8yQ1cYbs.mp4'
        }])

        this.$manager.finalizeSetup()
      }


    }

  }
</script>



// WEBPACK FOOTER //
// src/components/VRDemo.vue